export default __webpack_public_path__ + "static/media/main.b70a3e0f.png";